import React from "react";
import trim from "lodash/trim";
import PropTypes from "prop-types";

import FormGroup from "@mui/material/FormGroup";

import LookInput from "../../../ui/lookInput";
import Misc from "../../../../../misc/misc";
import LookAddressInput from "../../../ui/lookAddressInput";
import WithInputValidations from "../../../hocs/withInputValidations";


const GroheBillingAndShippingInputs = (props) => {

  const {addressObject, setAddressInfo, setAddressErrors, addressErrors} = props;

  const shippingInputChange = (property, value) => {
    setAddressInfo(property, value);
  }

  const getValidationErrors = (property, checkValue) => {
    const currentValue = trim(checkValue);
    const errors = [];

    switch (property) {
      case "address1": {
        if (!currentValue) {
          errors.push("look.inputs.errors.noAddress");
          return errors
        }
        break;
      }
      case "postal": {
        if (!currentValue) {
          errors.push("look.inputs.errors.missingPostal");
          return errors
        }
        if (!Misc.isZip(currentValue)) {
          errors.push("look.inputs.errors.incorrectPostal");
          return errors
        }
        break;
      }
    }
    return errors
  }

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => (
        <FormGroup className="gc-form gc-form--row">
          {Object.keys(addressObject).map(inputKey => {
            if (inputKey === "stateShort") {
              return null
            }
            if (inputKey === "address1") {
              return (
                <div className="gc-form__inputs-block" key={inputKey}>
                  <LookAddressInput property={inputKey}
                                    updateInputValidations={updateInputValidations}
                                    inputsValidated={inputsValidated}
                                    inputValue={addressObject[inputKey]}
                                    setInputValue={shippingInputChange}
                                    getValidationErrors={getValidationErrors}
                                    errorsObject={addressErrors}
                                    changeErrorsObject={setAddressErrors}
                                    isRequired={true} />
                </div>
              )
            }
            return (
              <div className="gc-form__inputs-block" key={inputKey}>
                <LookInput property={inputKey}
                           inputsValidated={inputsValidated}
                           inputValue={addressObject[inputKey]}
                           setInputValue={shippingInputChange}
                           getValidationErrors={getValidationErrors}
                           errorsObject={addressErrors}
                           changeErrorsObject={setAddressErrors}
                           isRequired={false} />
              </div>
            )
          })}
        </FormGroup>
      )}
    </WithInputValidations>
  )
};

GroheBillingAndShippingInputs.propTypes = {
  addressObject: PropTypes.object.isRequired,
  setAddressInfo: PropTypes.func.isRequired,
  addressErrors: PropTypes.object,
  setAddressErrors: PropTypes.func,
}

export default GroheBillingAndShippingInputs
